import { Animations } from '@fi-shared/utils/animations';
import { FiTaskV2Service } from '@fi-app/task-v2/fi-task-v2.service';
import { ChangeDetectionStrategy, Component, Input, OnDestroy, OnInit, ViewEncapsulation } from '@angular/core';
import { ITaskV2Log } from '@fi-app/task-v2/fi-task-v2';
import { BehaviorSubject, Observable, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { FiTaskSyncService } from '@fi-shared/fi-task-shared/fi-task-sync-service';
import { FiTaskActionType } from '@fi-app/task-v2/fi-task-v2-enums';

@Component({
    selector: 'fi-task-v2-log',
    templateUrl: './task-v2-log.component.html',
    styleUrls: ['./task-v2-log.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
    host: { class: 'fi-task-v2-log' },
    standalone: false,
    animations: [Animations.fadeHeight()],
})
export class TaskV2LogComponent implements OnInit, OnDestroy {
    @Input({ required: true }) taskId: number;
    @Input({ required: true }) updateTaskLog$: Observable<void>;
    @Input() isAutomatedTask: boolean;
    protected loading$ = new BehaviorSubject<boolean>(true);

    private _taskLogs$ = new BehaviorSubject<ITaskV2Log[]>([]);
    protected get taskLogs$() {
        return this._taskLogs$.asObservable();
    }

    constructor(
        private fiTaskV2Service: FiTaskV2Service,
        private fiTaskSyncService: FiTaskSyncService,
    ) {}

    public ngOnInit(): void {
        this.initTempTaskLog();

        this.subscribeToSyncTasks();
    }

    private subscribeToSyncTasks() {
        this.fiTaskSyncService.subscribeToTaskUpdatedBySync(this.taskId, this.ngOnDestroy$, (updatedTask) => {
            this.initTempTaskLog();
        });

        this.updateTaskLog$.pipe(takeUntil(this.ngOnDestroy$)).subscribe(() => {
            this.initTempTaskLog();
        });
    }

    private initTempTaskLog(): void {
        this.fiTaskV2Service.getTaskLog(this.taskId).then((logs: ITaskV2Log[]) => {
            if (this.isAutomatedTask) {
                logs = logs.filter((log) => log.ActionType !== FiTaskActionType.Create);
            }
            this._taskLogs$.next(logs);
            this.loading$.next(false);
        });
    }

    private ngOnDestroy$ = new Subject<void>();
    ngOnDestroy() {
        this.ngOnDestroy$.next();
        this.ngOnDestroy$.complete();
    }
}
